module.exports = __webpack_public_path__ + "img/windows-bleu@2x.c791351d.png";